module.exports = "/_next/static/images/13088553d659e72a046654cb1b281eb8-cards-and-device@1x.jpg";